// extracted by mini-css-extract-plugin
export default {"listItem":"src-core-components-CollapsibleItem-CollapsibleItem__listItem--SGdBG","listItemHeader":"src-core-components-CollapsibleItem-CollapsibleItem__listItemHeader--N_9_g"};